import React, { useState } from 'react';

const PrimeFactors = ({ onClose }) => {
  const [input, setInput] = useState<string>('');
  const [computedNumber, setComputedNumber] = useState<number | null>(null);
  const [primeFactors, setPrimeFactors] = useState<number[]>([]);
  const [primeFactoryList, setPrimeFactoryList] = useState<number[]>([]);
  const [computing, setComputing] = useState<boolean>(false);

  const findPrimeFactors = () => {
    if (!input || isNaN(Number(input)) || parseInt(input) <= 0) {
      alert('Please enter a valid positive number');
      return;
    }

    setComputing(true);
    setComputedNumber(parseInt(input));
    
    const factors = isPrimeFactory(parseInt(input));
    setPrimeFactors([factors]);
    setComputing(false);
  };

  const isPrimeFactory = (number) => {
    const factors = [];
    
    for (let i = 2; i <= number; i++) {
      while ((number % i) === 0) {
        factors.push(i);
        number /= i;
      }
    }
    
    // Get unique factors
    const uniqueFactors = factors.filter((value, index, self) => self.indexOf(value) === index);
    setPrimeFactoryList(factors);
    
    return uniqueFactors.length;
  };

  const resetForm = () => {
    setInput('');
    setComputedNumber(null);
    setPrimeFactors([]);
    setPrimeFactoryList([]);
    setComputing(false);
  };

  return (
    <div>
      <div className="mb-3">
        <label htmlFor="numberInput" className="form-label">Enter a number to find its prime factors:</label>
        <input
          type="number"
          className="form-control"
          id="numberInput"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="Enter a positive integer"
          min="1"
        />
      </div>

      <div className="mb-3">
        <button 
          className="btn btn-primary me-2"
          onClick={findPrimeFactors}
          disabled={computing || !input.trim()}
        >
          {computing ? 'Computing...' : 'Find Prime Factors'}
        </button>
        
        <button 
          className="btn btn-secondary"
          onClick={resetForm}
        >
          Reset
        </button>
      </div>

      {computedNumber && (
        <div className="mt-4">
          <div className="card">
            <div className="card-header">
              <h5>Prime Factor Analysis for {computedNumber}</h5>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-6">
                  <p><strong>Number of unique prime factors:</strong> {primeFactors}</p>
                  <p><strong>Prime factorization:</strong></p>
                  <p>{primeFactoryList.join(' × ')}</p>
                </div>
                <div className="col-md-6">
                  <p><strong>All factors found:</strong></p>
                  <div className="d-flex flex-wrap gap-1">
                    {primeFactoryList.map((factor, index) => (
                      <span key={index} className="badge bg-primary me-1">
                        {factor}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="mt-4">
        <h6>How it works:</h6>
        <ol>
          <li>Enter a positive integer</li>
          <li>The algorithm finds all prime factors of the number</li>
          <li>It shows both the unique prime factors count and the complete factorization</li>
          <li>For example: 12 = 2 × 2 × 3 (2 unique prime factors)</li>
        </ol>
      </div>
    </div>
  );
};

export default PrimeFactors;
